import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    items: []
  },

  getters: {
    items: state => {
        return state.items
    }
  },

  mutations: {
    setItems (currentState, items) {
        currentState.items = items
    },
    addItem (currentState, item) {
        currentState.items.push(item)
    }
  },

  actions: {
    fetch: ({commit, state}, data) => {
        let params = data || {};

        let uri = '/orders'
        return new Promise((resolve, reject) => {
            Vue.axios.get(uri, {params: params})
                .then(res => {
                    commit('setItems', res.data)
                    resolve(res.data)
                })
                .catch(err => {
                    console.log(err)
                })
        })
    },
    read: (context, id) => {
        let uri = '/orders/' + id
        return new Promise((resolve, reject) => {
            Vue.axios.get(uri)
                .then(res => {
                    resolve(res.data)
                })
                .catch(err => {
                    console.log(err)
                })
          })
    },
    submit: ({commit, state}, {data}) => {

    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./prompts/store/modules/Order.js
// module id = null
// module chunks = 